import { memo, useEffect, useRef, useState } from "react"
import { HStack, Input, Center, AspectRatio, Image, Float, Tag, Button } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import Slider from "react-slick";
import _ from "lodash";
import { useNavigate } from "react-router"
const HomeBanner = ({ data }) => {
    let sliderRef = useRef(null);
    const [products, setProducts] = useState([])
    const navigate = useNavigate();
    useEffect(() => {

        var data2 = _.shuffle(data);
        if(data2.length ==1){
            data2=  [...data2, data2[0]]
        }
        setProducts(data2);

    }, [data])

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        height: 50,
        autoplay: true,
       // lazyLoad: true
      
        // centerMode:true
    };
    return (
        <div style={{ marginBottom: 0, width:"99%" }} >
            <Slider  {...settings} ref={slider => {
                sliderRef = slider;
            }}>
                {products.map(product => {
                    return (
                        <AspectRatio bg="bg.muted" ratio={4 / 3} onClick={e => navigate(`/product/${product.id}`)} >
                            <div>


                                <Center >
                                    <Image src={product.thumbnail?.lg_url} ></Image>
                                </Center>

                                <Float placement={"top-start"} offsetX={24} offsetY={6} >
                                    {/* <div style={{  padding: 16 }}>
                                                  {product.variant?.variant_title}
                                              </div> */}
                                    <Tag.Root>
                                        <Tag.Label>{product.name}</Tag.Label>
                                    </Tag.Root>

                                </Float>

                          
                                <div></div>
                            </div>
                        </AspectRatio>
                    )
                })}





            </Slider>


        </div>
    )
}

export default memo(HomeBanner)